import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppServiceService } from 'src/app/api/app-service.service';
import { InputSelectModalPointsComponent } from 'src/app/component/input-select-modal-points/input-select-modal-points.component';
import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';
import { StorageService } from 'src/app/core/storage.service';

declare var config: any;
@Component({
  selector: 'app-point-history',
  templateUrl: './point-history.page.html',
  styleUrls: ['./point-history.page.scss'],
})
export class PointHistoryPage implements OnInit {

  // display skeleton text while loading points data, set default true 
  public loadingPointsHistory: boolean = true;
  // currently selected restaurant object
  public selectedRestaurant = null;
  public restaurantList = [];
  public pointHistory = [];
  public totalPointCount = 0;
  // wethere points recharge enabled or not in selected restaurant
  public selectedRestaurantRechargeIsEnabled = false;

  public successPayment: any = null;

  @ViewChild('poupmodal') poupmodal: TemplateRef<any>;
  @ViewChild('rechargeSuccess') rechargeSuccess: TemplateRef<any>;

  // this will set the default restaurant in point histories page
  // added with landing page points widget
  @Input() defaultRestaurant: any = null;

  constructor(public appService: AppServiceService, public storage: StorageService, private modalCtrl: ModalController, public translate: TranslateService,
    private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    setTimeout(() => {
      this.getRestaurantList();
    }, 2000);

  }


  getRestaurantList() {
    this.appService.getPointsEnabledAllRestaurants().then((pointsEnabledRestaurantsList: any) => {
      if (pointsEnabledRestaurantsList.status) {
        this.restaurantList = pointsEnabledRestaurantsList.data;

        if (this.restaurantList.length > 0) {
          // if there is a default restaurant has been set, then find it and set as default
          // otherwise get the first restaurant in the list
          if (this.defaultRestaurant) {
            let defaultRestaurantFound = this.restaurantList.find((restaurant) => restaurant.id === this.defaultRestaurant);
            if (defaultRestaurantFound) this.selectedRestaurant = defaultRestaurantFound;
            else this.selectedRestaurant = this.restaurantList[0];
          } else {
            this.selectedRestaurant = this.restaurantList[0];
          }
          this.checkPointRechargeEnabled();
          // console.log(JSON.parse(this.selectedRestaurant.payment_methods));
          this.getPointHistory();
        } else this.loadingPointsHistory = false;
      }
    })
  }

  openPaymentSuccess() {
    // console.log('this.appService.isFooterMenu : ' ,this.appService.isFooterMenu);

    this.route.queryParams.subscribe(async (param) => {
      // check if the query params has payment_status and restaurant id
      if (param.payment_status === 'true' && param.restaurant_id) {
        // findout recharged restaurant
        let rechargedRestaurant = this.restaurantList.find((restaurant) => restaurant.id == param.restaurant_id);
        // if currently selected restaurant is not the one user recharged, then set the selected restaurant as recharged restaurant object
        if (rechargedRestaurant && rechargedRestaurant.id !== this.selectedRestaurant.id) {
          this.selectedRestaurant = rechargedRestaurant;
          // refresh the points history but not calling openPaymentSuccess function (it's already called, all we want is to get recharged restaurant history)
          this.loadingPointsHistory = true;
          await this.getPointHistory(false);
        }

        this.loadingPointsHistory = false;
        // if selected restaurant has value nad point history available
        this.openPaymentSuccessFinal(param.point_history_id);
      }
    });
  }

  async openPaymentSuccessFinal(point_history_id) {
    if (this.selectedRestaurant && this.pointHistory && this.pointHistory.length) {
      let successPayment = this.pointHistory.find((historyOb) => (historyOb.id + '') === (point_history_id + ''));
      // console.log('successPayment : ', successPayment);
      if (successPayment) {
        this.successPayment = successPayment;

        const modal = await this.modalCtrl.create({
          component: InputSelectModalComponent,
          cssClass: 'select-modal',
          componentProps: {
            content: this.rechargeSuccess
          },
        });
        // hide cart button when popup opening
        this.appService.hideCartButton = true;

        modal.present();
        // console.log(modal);
        modal.onWillDismiss().then(async (event) => {
          // this.getPointHistory();

          // when user force to purchase points in checkout process
          // once the recharge is done redirect back to the selected restaurant menu page and
          // open checkout process automatically
          if (successPayment && successPayment.extra_details) {
            let extraData = successPayment.extra_details;

            if (extraData && (extraData.forcedToRecharge === true || extraData.forcedToRecharge === 'true')) {
              this.router.navigate(['restaurant', this.appService.appObject.selectedRestaurantDetails.slug], {
                queryParams: {
                  pointRecharge: true
                },
                replaceUrl: true
              });
              return;
            }
          }

          this.router.navigate(['point-history'], { replaceUrl: true });

        });
      }
    }
  }

  /**
   * Fetch points history data of the user in selected restaurant
   * @param openPaymentSuccess boolean call openPaymentSuccess function after retriving points history
   */
  async getPointHistory(openPaymentSuccess: boolean = true) {
    this.loadingPointsHistory = true;
    await this.appService.getPointHistory(this.selectedRestaurant.id).then((response: any) => {
      if (response.status) {
        this.pointHistory = response.data;
        this.totalPointCount = response.total_points ? response.total_points.toFixed(2) : 0;

        for (let index = 0; index < this.pointHistory.length; index++) {
          const element = this.pointHistory[index];
          if (element.extra_details) element.extra_details = JSON.parse(element.extra_details);
        }

        if (openPaymentSuccess) this.openPaymentSuccess();
      }
    }).catch((error) => {
      console.log('error : ', error);
    }).finally(() => {
      this.loadingPointsHistory = false;
    });
  }

  /**
   * Check whether selected restaurant has points recharge enabled or not
   */
  checkPointRechargeEnabled() {
    let methods = JSON.parse(this.selectedRestaurant.payment_methods);
    for (let index = 0; index < methods.length; index++) {
      const method = methods[index];
      if (method.id == 'points' && method?.pointsConfigurations?.points_recharge_enabled == 'true') {
        this.selectedRestaurantRechargeIsEnabled = true;
      }
    }
  }
  /**
   * Will trigger when user switch restaurants from the list
   * @param restaurant selected restaurant object
   */
  selectRestaurant(restaurant) {
    this.selectedRestaurant = restaurant;
    this.checkPointRechargeEnabled();
    this.getPointHistory();
  }


  /**
   * Will return point transaction type display text
   * @param type points transaction type
   * @returns 
   */
  getRandomString(type: string): string {
    switch (type) { // Adding 1 since indices usually start from 0
      case 'topup':
        return 'recharge';
      case 'claim':
        return 'revert';
      case 'spend':
        return 'purches';
      case 'referral_reward':
        return 'referral';
      case 'referral_registration':
        return 'referral';
      default:
        return ''; // No class added for other values of i
    }
  }

  /**
   * Open payments modal popup
   */
  async openPaymentModal() {
    const modal = await this.modalCtrl.create({
      component: InputSelectModalPointsComponent,
      cssClass: 'select-modal',
      componentProps: {
        selectedRestaurant: this.selectedRestaurant
      },
    });
    // hide cart button when popup opening
    this.appService.hideCartButton = true;

    modal.present();
    // console.log(modal);
    modal.onWillDismiss().then(async (event) => {
      if (config.plf == 'app') {
        if (event.data.transaction_status === 'success') {
          await this.getPointHistory(false);
          this.openPaymentSuccessFinal(event.data.id);
        }
      } else {
        this.getPointHistory();
      }
    });
  }

  async openModal(content: TemplateRef<any>) {
    const modal = await this.modalCtrl.create({
      component: InputSelectModalComponent,
      cssClass: 'select-modal',
      componentProps: {
        content: content, // Pass the content as a TemplateRef
      },
    });
    // hide cart button when popup opening
    this.appService.hideCartButton = true;

    modal.present();
  }

  /**
   * Will return formatted date string yyyy-mm-dd hh:mm
   * @param dateString string date value 
   * @returns 
   */
  formatDateString(dateString) {
    return this.appService.formatDateObject(new Date(dateString), true);
  }

}
